import { usePost } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';
import { Account, Rate } from '@app/models';

export function useCreateAccount() {
  const post = usePost(true, "ams");
  const createAccount = (creditLimit: number | string, creditLimitIncreasePreference: string, productId: string, ratesList: Rate[], paymentDay: number | null, statementDay: number | null) => {
    const interestRates = ratesList.map((r) => {
      return {
        spendType: r.spendType,
        feeCategory: r.feeCategory,
        subledgerType: r.subledgerType,
        rate: r.rate,
      };
    });

    return post<Account>(`/api/proxy/ams/account-service/account`, {
      productId,
      creditLimit,
      creditLimitIncreasePreference,
      interestRates,
      paymentDay,
      statementDay,
    });
  };

  return useMutationWithErrorHandling({
    mutationFn: async ({
      creditLimit,
      creditLimitIncreasePreference,
      productId,
      ratesList,
      paymentDay,
      statementDay
    }: {
      creditLimit: number | string;
      creditLimitIncreasePreference: string;
      productId: string;
      ratesList: Rate[];
      paymentDay: number | null;
      statementDay: number | null;
    }) => await createAccount(creditLimit, creditLimitIncreasePreference, productId, ratesList, paymentDay, statementDay),
  });
}
